import { nextTick, ref, type Ref } from 'vue'

export interface Shake {
  /** True while the shake runs; bind it to `motion-safe:animate-shake`. */
  shaking: Ref<boolean>
  /** Shakes once if the field is invalid after the owner has handled the blur. */
  shakeIfInvalid: () => void
  /** Ends the shake; bind it to the shaking element's `animationend`. */
  onAnimationEnd: (event: AnimationEvent) => void
}

/** Shakes a field once when it loses focus holding a value its owner refuses. */
export function useShake(invalid: () => boolean): Shake {
  const shaking = ref(false)

  function shakeIfInvalid(): void {
    void nextTick(() => {
      if (invalid()) shaking.value = true
    })
  }

  function onAnimationEnd(event: AnimationEvent): void {
    if (event.animationName === 'shake') shaking.value = false
  }

  return { shaking, shakeIfInvalid, onAnimationEnd }
}
